const planTranslations = {
    en: {
      title: "Select Your Plan",
      monthly: "Monthly",
      yearly: "Yearly"
    },
    pt: {
      title: "Selecione Seu Plano",
      monthly: "Mensal",
      yearly: "Anual"
    },
    es: {
      title: "Selecciona Tu Plan",
      monthly: "Mensual",
      yearly: "Anual"
    },
    fr: {
      title: "Choisissez Votre Plan",
      monthly: "Mensuel",
      yearly: "Annuel"
    },
    de: {
      title: "Wählen Sie Ihren Plan",
      monthly: "Monatlich",
      yearly: "Jährlich"
    },
    it: {
      title: "Seleziona Il Tuo Piano",
      monthly: "Mensile",
      yearly: "Annuale"
    },
    ru: {
      title: "Выберите свой план",
      monthly: "Ежемесячно",
      yearly: "Ежегодно"
    },
    zh: {
      title: "选择您的计划",
      monthly: "月付",
      yearly: "年付"
    },
    ja: {
      title: "プランを選択",
      monthly: "月計画",
      yearly: "年計画"
    },
    ko: {
      title: "프랜 선호",
      monthly: "달호",
      yearly: "한호"
    },
    hi: {
      title: "अपनी योजना चुनें",
      monthly: "मासिक",
      yearly: "वार्षिक"
    },
    ar: {
      title: "اختر الخطة الخاصة بك",
      monthly: "شهري",
      yearly: "سنوي"
    },
    tr: {
      title: "Planınızı Seçin",
      monthly: "Aylık",
      yearly: "Yıllık"
    },
    nl: {
      title: "Selecteer Uw Plan",
      monthly: "Maandelijks",
      yearly: "Jaarlijks"
    },
    sv: {
      title: "Välj Din Plan",
      monthly: "Månatlig",
      yearly: "Årlig"
    },
    no: {
      title: "Velg Din Plan",
      monthly: "Månedlig",
      yearly: "årlig"
    },
    pl: {
      title: "Wybierz Swój Plan",
      monthly: "Miesięczny",
      yearly: "Roczny"
    },
    he: {
      title: "בחר את התכנית שלך",
      monthly: "חודשי",
      yearly: "שנתי"
    },
    fi: {
      title: "Valitse Suunnitelmasi",
      monthly: "Kuukausittain",
      yearly: "Vuosittain"
    },
    el: {
      title: "Επιλέξτε το πλάνο σας",
      monthly: "Μηνιαίο",
      yearly: "Ετήσιο"
    },
    da: {
      title: "Vælg Din Plan",
      monthly: "Månedlig",
      yearly: "Årlig"
    }
  };
  
  export default planTranslations;
  